<template>
  <div class="question-history">
    <div class="grid grid--bleed">
      <div class="grid__col-24">
        <button
          class="btn btn--text-link btn--expander help-text__toggle js-help-text-toggle"
          type="button"
          @click="toggle()"
        >
          {{ isOpen ? 'Hide' : 'Show' }} question history
        </button>
      </div>
    </div>

    <!-- Error loading history-->
    {{ errored ? 'An error occured fetching the question history' : '' }}
    <div class="question-history__content" v-if="isOpen">
      <!-- No question history -->
      <template v-if="!questionHistory.length">
        No history to display
      </template>
      <ul class="question-history__list">
        <li
          v-for="history in questionHistory"
          :key="history.index"
          class="question-history__item"
        >
          <!-- Actor information -->
          <div class="question-history__actor-info">
            <template v-if="history.type == 'answer'">
              {{ history.question_label }} updated by
            </template>
            <template v-else-if="history.type == 'note'">
              Note added by
            </template>
            {{ history.user_fullname }} ({{ history.user_role }})
            {{ history.pretty_date}}
          </div>

          <!-- Answer history items -->
          <div
            class="question-history__to-from"
            v-if="history.type == 'answer'"
          >
            <div class="question-history__from" v-if="history.from_value">
              <div v-if="Array.isArray(history.from_value)" class="question-history__to-content">
                <strong>From:</strong> <br />
                    <ul>
                      <li v-for="item in history.from_value" :key="item.fileName">
                        {{ item.fileName }}
                      </li>
                    </ul>
              </div>
              <div v-else class="question-history__to-content">
                <strong>From:</strong> <br />
                {{ history.from_value }}
              </div>
            </div>
            <div class="question-history__to" v-if="history.to_value">
              <div v-if="Array.isArray(history.to_value)" class="question-history__to-content">
                <strong>To:</strong> <br />
                    <ul>
                      <li v-for="item in history.to_value" :key="item.fileName">
                        {{ item.fileName }}
                      </li>
                    </ul>
              </div>
              <div v-else class="question-history__to-content">
                <strong>To:</strong> <br />
                {{ history.to_value }}
              </div>
            </div>
          </div>

          <!-- Notes items -->
          <div class="question-history__notes" v-else-if="history.type == 'note'">
            {{ history.note_text }}
            <div v-if="history.requires_action">
              <strong>* Action required</strong>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import formengineApi from '../services/api/formengineApi';

export default {
  props: {
    userPageInstanceId: {
      type: Number,
      requured: true,
    },
    questionId: {
      type: Number,
      requured: true,
    },
  },

  data() {
    return {
      questionHistory: {},
      isOpen: false,
      errored: false,
    };
  },

  methods: {
    // Toggle the history
    toggle() {
      if (!this.isOpen && !this.questionHistory.length) {
        this.loadHistory();
      } else {
        this.isOpen = !this.isOpen;
      }
    },
    // Check the user permission
    loadHistory() {
      let params = {
        userPageInstance: this.userPageInstanceId,
        question: this.questionId,
      };
      formengineApi
        .questionHistory(params)
        .then((response) => {
          this.questionHistory = response.data;
        })
        .then(() => {
          // Open the toggle
          this.isOpen = true;
        })
        .catch((error) => {
          this.isOpen = false;
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    // Format the date
    formatDate(dateString) {
      let date = new Date(Date.parse(dateString));

      return (
        date.getDay() +
        ' ' +
        date.toLocaleString('default', { month: 'long' }) +
        ' ' +
        date.getFullYear()
      );
    },
  },
};
</script>
